import { render, staticRenderFns } from "./MyComplaints.vue?vue&type=template&id=efb82f4e&"
import script from "./MyComplaints.vue?vue&type=script&lang=js&"
export * from "./MyComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports